<template>
		<!-- shareMask -->
	<div class="qrCodeMask">
		<div class="mask"></div>
		<div class="qrCode">
			<img src="../../static/images/funreport-qrcode.png" height="123" width="123">
			<p>关注公众号</p>
			<p>自动收到好友的性格分析报告</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'qrcodeMask',
}
</script>

<style scoped lang='scss' >
$font-size-base:32; // Base on 320rem * 0.5;
@function topx($rem) {
  @return $rem/ $font-size-base;
}
	.qrCodeMask {
		.mask {
			position: fixed;
			z-index: 99;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: #000;
			opacity: .75;
		}
		.qrCode {
			width: topx(200rem * 0.5);
			position: fixed;
			z-index: 100;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: topx(40rem * 0.5) topx(50rem * 0.5);
			background: #fff;
			border-radius: topx(50rem * 0.5);
			img {
				width: topx(200rem * 0.5);
				height: topx(200rem * 0.5);
			}
			p {
				font-size: topx(22rem * 0.5);
				line-height: topx(36rem * 0.5);
				text-align: center;
				color: #000;
				margin:0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// qrcodeMask.vue?6d404c1b